import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {TimelineLite} from "gsap";
import {RoadKill} from "../RoadKill";
import {RoadKillGameConfig} from "../RoadKillGameConfig";
import {RoadKillUtils} from "../utils/RoadKillUtils";

export class RoadKillIdleNormalPresentation implements FlowStatePresentation {
    private _tl: TimelineMax | undefined;

    constructor() {

    }

    public start(flowStateController: FlowStateController) {
        //flowStateController.setSkipCallback(() => this.skip(flowStateController));
        this._tl = new TimelineLite();
        this._tl.add(() => {
            this.finish(flowStateController);
        });

        if (RoadKill.winToggle.checkToRun()) {
            this._tl.add(RoadKill.winToggle.preWinToggle());
            if (!RoadKill.isActionSpinsActive) {
                this._tl.add(() => RoadKill.winToggle.playWinToggle());
            }
            RoadKill.jumpingWildView.reset();
        } else {
            if (RoadKill.model.gameData && RoadKill.model.betWayWins.length > 0 && RoadKillUtils.allReelsInIdleState()) {
                this._tl.add(() => {
                    this.disableNonWinSyms();
                }, 0.5)
            }
        }
    }

    private disableNonWinSyms(): void {
        for (let reelId: number = 0; reelId < RoadKillGameConfig.REELS_NUM; reelId++) {
            for (let symId: number = 0; symId < RoadKill.model.evaluatedArea[0].length; symId++) {
                if (RoadKillUtils.allReelsInIdleState()) {
                    RoadKill.reelView.getVisibleSymbolAt(reelId, symId).markNonWin(false);
                }
            }
        }
    }

    private skip(flowStateController: FlowStateController): void {
        if (this._tl != undefined) {
            this._tl.kill();
            delete this._tl;
            this.finish(flowStateController);
        }
    }

    private finish(flowStateController: FlowStateController) {
        flowStateController.finish();
    }


}